import getDistanceFromLatLonInMeters from './getDistanceFromLatLonInMeters';

const METERS_PER_MILE = 1609.344;

const LOCALOPS_REGION_AUTHORITIES = Object.freeze({
  camden: Object.freeze({
    slug: 'camden',
    centerLat: 36.05895,
    centerLng: -88.09782,
    radiusMiles: 12,
    toleranceMiles: 1,
  }),
});

const normalizeRegionSlug = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

const normalizeCoordinates = (location) => {
  if (!location) return null;
  if (Array.isArray(location) && location.length >= 2) {
    const lon = Number(location[0]);
    const lat = Number(location[1]);
    if (Number.isFinite(lat) && Number.isFinite(lon)) return { lat, lon };
    return null;
  }
  if (Array.isArray(location.coordinates) && location.coordinates.length >= 2) {
    const lon = Number(location.coordinates[0]);
    const lat = Number(location.coordinates[1]);
    if (Number.isFinite(lat) && Number.isFinite(lon)) return { lat, lon };
    return null;
  }
  const lat = Number(location.lat ?? location.latitude);
  const lon = Number(location.lon ?? location.lng ?? location.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  return { lat, lon };
};

export const getLocalOpsRegionAuthority = (regionSlug) =>
  LOCALOPS_REGION_AUTHORITIES[normalizeRegionSlug(regionSlug)] || null;

export const hasLocalOpsRegionAuthority = (regionSlug) =>
  Boolean(getLocalOpsRegionAuthority(regionSlug));

export const isCoordinateInLocalOpsRegion = (location, regionSlug) => {
  const authority = getLocalOpsRegionAuthority(regionSlug);
  const coords = normalizeCoordinates(location);
  if (!authority || !coords) return false;
  const distanceMeters = getDistanceFromLatLonInMeters(
    Number(authority.centerLat),
    Number(authority.centerLng),
    coords.lat,
    coords.lon,
  );
  if (!Number.isFinite(distanceMeters)) return false;
  const allowedMeters =
    (Number(authority.radiusMiles) + Number(authority.toleranceMiles)) *
    METERS_PER_MILE;
  return distanceMeters <= allowedMeters;
};
